import * as ko from 'knockout';

ko.bindingHandlers['quote'] = {
    init: () => {
        return { controlsDescendantBindings: true }; // Prevent binding on the descendant nodes
    }
};